import * as React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Redirect deprecated shared-page URLs to normal page URLs.
 * The shared page library feature has been shut down, but external links
 * (bookmarks, emails, wikis) still reference the old URL format.
 * This route catches those URLs and redirects to the working page URL.
 * Uses a wildcard path to handle any sub-path (live, admin, etc.).
 */
const SharedPageRedirectRoute = () => {
    const { pageId, "*": rest } = useParams();
    const location = useLocation();
    const subPath = rest || "live";
    const targetPath = `/page/${pageId}/${subPath}${location.search}`;
    return <Navigate to={targetPath} replace />;
};

export const sharedPageRoutes = [
    {
        path: "/shared-page/:instanceId/:pageId/*",
        content: <SharedPageRedirectRoute />,
        header: () => <></>,
    }
];
